import api from "./api";
import { generateErrorMessage } from "../utils/message";

/*Email Logs*/
export const fetchEmailLogsFromAPI = async (page = 1, perPage = 10, search = "", columnFilters = {}) => {
  try {
    // Build params object with column-specific filters
    const params = {
      page,
      per_page: perPage
    };

    // Add search parameter if provided (for backward compatibility)
    if (search) {
      params.search = search;
    }

    // Add column-specific parameters
    if (columnFilters.recipient_email) params.recipient_email = columnFilters.recipient_email;
    if (columnFilters.status) params.status = columnFilters.status;
    if (columnFilters.email_type) params.email_type = columnFilters.email_type;

    const response = await api.get("/mailer/email-logs", {
      params: params,
    });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "email log");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

